import BusinessTypes from "Containers/BusinessInformations/types"

const initialState = {
  docs: {},
  users: [],
  roles: [],
  rolesOfUser: [],
  groups: [],
  myGroups: [],
  group: {},
  logo: {
    lastUpdate: 0,
  },
  emailChecked: "",
  emailAlreadyUsed: false,
  linkNavBusiness: "customization",
  usersKeycloak: [],
  isLoadingKeycloak: false,
}

function businessReducer(state = initialState, { type, payload }) {
  switch (type) {
    case BusinessTypes.GET_BUSINESS_INFORMATIONS_SUCCESS:
      return {
        ...state,
        docs: payload.docs,
      }
    case BusinessTypes.GET_BUSINESS_USERS_SUCCESS:
      return {
        ...state,
        users: payload.body,
      }
    case BusinessTypes.UPLOAD_BUSINESS_LOGO_SUCCESS:
      return {
        ...state,
        logo: {
          lastUpdate: payload,
        },
      }
    case BusinessTypes.GET_BUSINESS_LOGO_SUCCESS:
      return {
        ...state,
        logo: {
          lastUpdate: payload,
        },
      }
    case BusinessTypes.RESET_CHECKED_EMAIL:
      return {
        ...state,
        emailChecked: "",
        emailAlreadyUsed: false,
      }
    case BusinessTypes.SET_CHECKED_EMAIL:
      return {
        ...state,
        emailChecked: payload,
      }
    case BusinessTypes.GET_ALREADY_USED_EMAIL_SUCCESS:
      return {
        ...state,
        emailAlreadyUsed: payload.emailIsAlreadyUsed,
      }
    case BusinessTypes.SET_LINK_NAVBAR_BUSINESS:
      return {
        ...state,
        linkNavBusiness: payload,
      }
    case BusinessTypes.RESET_LINK_NAVBAR_BUSINESS:
      return {
        ...state,
        linkNavBusiness: "customization",
      }
    // Keycloak
    case BusinessTypes.GET_USERS_KEYCLOAK:
      return {
        ...state,
        usersKeycloak: payload,
      }
    case BusinessTypes.SET_LOADING_KEYCLOAK:
      return {
        ...state,
        isLoadingKeycloak: true,
      }
    case BusinessTypes.RESET_LOADING_KEYCLOAK:
      return {
        ...state,
        isLoadingKeycloak: false,
      }
    //******************* ROLES *************************
    case BusinessTypes.GET_ROLES_SUCCESS:
      return { ...state, roles: payload }
    case BusinessTypes.GET_ROLES_OF_USER_SUCCESS:
      return { ...state, rolesOfUser: payload }
    //******************* GROUP *************************
    case BusinessTypes.GET_BUSINESS_GROUP_SUCCESS:
      return { ...state, groups: payload.body }
    case BusinessTypes.GET_MY_GROUPS_SUCCESS:
      return { ...state, myGroups: payload.body }
    case BusinessTypes.GET_BUSINESS_GROUP_BY_ID_SUCCESS:
      return { ...state, group: payload.body }
    case BusinessTypes.SET_PRIMARY_ACTION_COLOR:
      return { ...state, docs: { ...state.docs, primaryActionColor: payload || "" } }
    case BusinessTypes.SET_SECONDARY_COLOR:
      return { ...state, docs: { ...state.docs, secondaryColor: payload || "" } }
    case BusinessTypes.SET_BANNER_COLOR:
      return { ...state, docs: { ...state.docs, bannerColor: payload || "" } }
    case BusinessTypes.SET_SEPARATOR_COLOR:
      return { ...state, docs: { ...state.docs, separatorColor: payload || "" } }
    default:
      return state
  }
}

export default businessReducer
